import React, { useEffect, useState, useRef } from "react";
import IconCollection from "../../IconCollection/IconCollection";
import "./Players.css";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useParams } from "react-router-dom";
import Loading from '../../Component/Loading/Loading';
import Loader from '../../Component/Loader/Loader';
import { setQuarterOptions, submitPlayersAndMatchData, updateTeamOneOfficial, updateTeamTwoOfficial,updatePostingDataReset,updateEventType } from '../../redux/reducers/playersReducer';
import Official from './Official';
import PlayerAddForm from './PlayerAddForm';
import TableHeader from './TableHeader';
import TableBody from './TableBody';
import { fiveXFiveDefaultPeriod, fiveXFiveOvertimePeriod, toggleFoul, toggleGoalAnytimeDuringOvertime, toggleGoalWithinLast2Minutes, toggleOutOfBounds, toggleShotClockCheck, toggleShotClockViolation, toggleTimeout, topTimerWhenFoulCalled } from '../../redux/reducers/settingReducer';

const Players = () => {
  const { eventId } = useParams();

  const [loading, setLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)

  // Add a ref to track the latest data
  const latestEventDataRef = useRef(null);

  async function getEventData(token) {
    try {
      const apiUrl = `${process.env.REACT_APP_API_ROOT}/api/get_event/${eventId}/`;


      const response = await axios.get(apiUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });





      if (response.data == null) {

        setErrorMessage(true)
        return null;
      } else {

        // Store in ref for immediate access
        latestEventDataRef.current = response.data;
        return response.data;
      }

    } catch (error) {
      console.error("Error in getEventData:", error);
      setErrorMessage(true)
      throw error;
    }
  }
  const [tab, setTab] = useState("team1");
  const token = window.localStorage.getItem("token");
  const [searchUserID, setSearchUserID] = useState();
  const [searchUserID2, setSearchUserID2] = useState();
  const [selectedPlayers, setSelectedPlayers] = useState([]);
  const [selectedPlayers2, setSelectedPlayers2] = useState([]);
  const [teamOneAddModal, setTeamOneAddModal] = useState(false);
  const [teamTwoAddModal, setTeamTwoAddModal] = useState(false);
  const [eventDataReload, setEventDataReload] = useState(false);
  const settingReducer = useSelector((state) => state.settingReducer);
  const [eventData, setEventData] = useState(null);
  const eventType = eventData?.team_a_event_type_id == 9 ? "3x3" : "5x5";
  const playersReducer = useSelector((state) => state.playersReducer);
  const { teamOneOfficial, teamTwoOfficial,postingData } = playersReducer
  const teamOnePlayerPlayingLength = selectedPlayers?.filter(player => player.present).length
  const teamTwoPlayerPlayingLength = selectedPlayers2?.filter(player => player.present).length
  const event_date_start = eventData?.lock_roaster_date
  const getPeriodList = async () => {
    try {
      const response = await axios.get(`${process.env.REACT_APP_API_ROOT}` + '/api/get_period_list/2900/', {
        headers: {
          'Authorization': `${token}`
        }
      });

      // Transform response data
      const responseData = response.data.peiods; // Typo here, should be 'periods' instead of 'peiods'
      const transformedData = responseData.map(period => {
        return {
          value: period,
          label: period
        };
      });

      return transformedData;
    } catch (error) {
      console.error('Error:', error);
      throw error; // Rethrow the error to handle it in the parent component
    }
  };


  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getPeriodList();
        dispatch(setQuarterOptions(data));
      } catch (error) {
        console.error('Error fetching period list:', error);
      }
    };

    fetchData();
  }, []);

const handleEventType = () => {
  dispatch(updateEventType(eventData?.team_a_event_type_id ? eventData?.team_a_event_type_id : eventData?.team_b_event_type_id))
}


  const [teamOneOfficialLoading, setTeamOneOfficialLoading] = useState(false);
  const [teamTwoOfficialLoading, setTeamTwoOfficialLoading] = useState(false);

  useEffect(() => {
    const fetchOfficials = async (teamId) => {
      const res = await axios.get(
        `${process.env.REACT_APP_MANAGER_API}/api/v1/events/officials`,
        {
          params: { event_group_id: eventData.event_group_id, team_id: teamId, limit: 100 },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const rows = res.data?.data || [];
      // Map to the shape Official.js expects: { code, officials: [{ official_name }], team, team_code }
      return rows.map(o => ({
        code: o.customer_code || o.customer_short_name || `ID-${o.customer_id || ''}`,
        officials: [{ official_name: o.designation || o.official_role_name || 'Official' }],
        team: o.team_name || '',
        team_code: `TC${o.team_id}`,
      }));
    };

    const fetchOfficialList = async () => {
      if (!eventData) return;
      setTeamOneOfficialLoading(true);
      setTeamTwoOfficialLoading(true);
      try {
        const [teamA, teamB] = await Promise.all([
          fetchOfficials(eventData.event_team_a_id),
          fetchOfficials(eventData.event_team_b_id),
        ]);
        dispatch(updateTeamOneOfficial(teamA));
        dispatch(updateTeamTwoOfficial(teamB));
      } catch (error) {
        console.error('Error fetching official list:', error);
      } finally {
        setTeamOneOfficialLoading(false);
        setTeamTwoOfficialLoading(false);
      }
    };

    fetchOfficialList();
  }, [eventData]);

  useEffect(() => {
    fetchEventData(token);
  }, [eventId, eventDataReload]);

  async function fetchEventData(token) {
    try {
      const eventData = await getEventData(token);
      setEventData(eventData);
      setEventDataReload(false);
    } catch (error) {
      console.error("Error fetching event data:", error);
    }
  }

  // Called by PlayerAddForm after a successful roster add
  const handlePlayerAdded = () => {
    setEventDataReload(true);
  };









  const maxPlayers = eventType === "5x5" ? 5 : 3;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const goBack = () => {
    navigate(-1);
  };
  const handlePlayerAndOfficialData = async () => {
    setLoading(true)
    await handleRosterJoin()

    const eventData = await getEventData(token);
    if (eventData) {
      dispatch(submitPlayersAndMatchData(eventData));
      toast.success(`Data added successfully`)
      const eventTitle = `${eventData.event_code} ${eventData.team_a_name} vs  ${eventData.team_b_name}`
      localStorage.setItem("eventTitle", eventTitle);
      setLoading(false)
    }
  };

  const handleGoToControlPage = async () => {


    // First, handle roster join
    await handleRosterJoin();



    // Use the latest data from ref for validation
    const currentData = latestEventDataRef.current || eventData;


    if (currentData?.team_a_rosters?.length < maxPlayers || !currentData?.team_a_rosters?.length) {

      toast.error(`You must select at least ${maxPlayers} players for ${currentData.team_a_short_name}`)
    } else if (currentData?.team_b_rosters?.length < maxPlayers || !currentData?.team_b_rosters?.length) {

      toast.error(`You must select at least ${maxPlayers} players for ${currentData.team_b_short_name}`)
    } else if (currentData?.team_a_rosters?.length >= maxPlayers && currentData?.team_b_rosters.length >= maxPlayers) {

      setLoading(true)

      try {
        // Force refresh by setting eventDataReload to true
        setEventDataReload(true);

        // Wait a bit for the state to update
        await new Promise(resolve => setTimeout(resolve, 200));

        const eventDataNew = await getEventData(token);


        // Use the ref data as fallback
        const dataToUse = eventDataNew || latestEventDataRef.current;

        if (dataToUse) {
          if(postingData && postingData.length > 0 && postingData[0].event_id != eventId){
            dispatch(updatePostingDataReset())

          }

          // Dispatch immediately without setTimeout
          handleEventType()
          dispatch(submitPlayersAndMatchData(dataToUse));

          const eventTitle = `${dataToUse.event_code} ${dataToUse.team_a_name} vs  ${dataToUse.team_b_name}`
          localStorage.setItem("eventTitle", eventTitle);
          setLoading(false)
          navigate(`/control-page?eid=${eventId}`);
        } else {

          setLoading(false);
          toast.error("Failed to fetch event data");
        }
      } catch (error) {
        console.error("Error in handleGoToControlPage:", error);
        setLoading(false);
        toast.error("Error fetching event data");
      }
    }
  }
  const handleGoToStarterSubstitution = async () => {
    await handleRosterJoin()

    if (eventData?.team_a_rosters?.length < maxPlayers || !eventData?.team_a_rosters?.length) {
      toast.error(`You must select at least ${maxPlayers} players for ${eventData.team_a_short_name}`)
    } else if (eventData?.team_b_rosters?.length < maxPlayers || !eventData?.team_b_rosters?.length) {
      toast.error(`You must select at least ${maxPlayers} players for ${eventData.team_b_short_name}`)
    } else if (eventData?.team_a_rosters?.length >= maxPlayers && eventData?.team_b_rosters.length >= maxPlayers) {
      setLoading(true)
      const eventData = await getEventData(token);
      if (eventData) {
        handleEventType()
        dispatch(submitPlayersAndMatchData(eventData));
        const eventTitle = `${eventData.event_code} ${eventData.team_a_name} vs  ${eventData.team_b_name}`
        localStorage.setItem("eventTitle", eventTitle);
        setLoading(false)
        navigate(`/starter-substitution/${eventId}`);
      }
    }
  }



  useEffect(() => {
    if (!eventData) return;

    // Merge server rosters into local selectedPlayers, preserving local
    // present/startinglinup edits for existing rosters while adding new ones.
    if (eventData.team_a_rosters) {
      setSelectedPlayers(prev => {
        const existingIds = new Set(prev.map(p => p.r_id));
        const updated = prev.map(p => {
          const server = eventData.team_a_rosters.find(r => r.roster_id === p.r_id);
          return server ? p : p; // keep local state for existing
        });
        const newRosters = eventData.team_a_rosters
          .filter(r => !existingIds.has(r.roster_id))
          .map(player => ({
            r_id: player.roster_id,
            t_id: eventData.event_team_a_id,
            event_id: eventData.event_id,
            eg_id: eventData.event_group_id,
            present: player.is_present,
            startinglinup: player.is_startinglinup,
            play_sec: player.play_sec,
          }));
        if (prev.length === 0) {
          // First load — use all server data
          return eventData.team_a_rosters.map(player => ({
            r_id: player.roster_id,
            t_id: eventData.event_team_a_id,
            event_id: eventData.event_id,
            eg_id: eventData.event_group_id,
            present: player.is_present,
            startinglinup: player.is_startinglinup,
            play_sec: player.play_sec,
          }));
        }
        return [...updated, ...newRosters];
      });
    }

    if (eventData.team_b_rosters) {
      setSelectedPlayers2(prev => {
        const existingIds = new Set(prev.map(p => p.r_id));
        const newRosters = eventData.team_b_rosters
          .filter(r => !existingIds.has(r.roster_id))
          .map(player => ({
            r_id: player.roster_id,
            t_id: eventData.event_team_b_id,
            event_id: eventData.event_id,
            eg_id: eventData.event_group_id,
            present: player.is_present,
            startinglinup: player.is_startinglinup,
            play_sec: player.play_sec,
          }));
        if (prev.length === 0) {
          return eventData.team_b_rosters.map(player => ({
            r_id: player.roster_id,
            t_id: eventData.event_team_b_id,
            event_id: eventData.event_id,
            eg_id: eventData.event_group_id,
            present: player.is_present,
            startinglinup: player.is_startinglinup,
            play_sec: player.play_sec,
          }));
        }
        return [...prev.filter(p => eventData.team_b_rosters.some(r => r.roster_id === p.r_id)), ...newRosters];
      });
    }
  }, [eventData])



  // Function to handle select/unselect all players for Team One
  const handleSelectUnselectAllTeamOne = () => {

    const allSelected = eventData?.team_a_rosters.every(player => selectedPlayers.some(p => p.r_id === player.roster_id && p.present));

    if (allSelected) {

      const newSelectedPlayers = selectedPlayers.map(player => ({
        ...player,
        present: false,
      }));
      setSelectedPlayers(newSelectedPlayers);
    } else {

      const newSelectedPlayers = eventData?.team_a_rosters.map(player => ({
        r_id: player.roster_id,
        t_id: eventData.event_team_a_id,
        event_id: eventData.event_id,
        eg_id: eventData.event_group_id,
        present: true,
        startinglinup: false,
        play_sec: 0,
      }));
      setSelectedPlayers(newSelectedPlayers);
    }
  };


  // Function to handle select/unselect all players for Team Two
  const handleSelectUnselectAllTeamTwo = () => {
    const allSelected = eventData?.team_b_rosters.every(player => selectedPlayers2.some(p => p.r_id === player.roster_id && p.present));

    if (allSelected) {
      // If all are selected, unselect all (set present to false)
      const newSelectedPlayers2 = selectedPlayers2.map(player => ({
        ...player,
        present: false,
      }));
      setSelectedPlayers2(newSelectedPlayers2);
    } else {
      // If not all are selected, select all (set present to true)
      const newSelectedPlayers2 = eventData?.team_b_rosters.map(player => ({
        r_id: player.roster_id,
        t_id: eventData.event_team_b_id,
        event_id: eventData.event_id,
        eg_id: eventData.event_group_id,
        present: true,
        startinglinup: false,
        play_sec: 0,
      }));
      setSelectedPlayers2(newSelectedPlayers2);
    }
  };

  const handlePlayerJoin = (player) => {

    // Check if the player is already selected
    const isSelected = selectedPlayers.some(p => p.r_id === player.roster_id);

    if (isSelected) {

      const updatedPlayers = selectedPlayers.map(p => p.r_id === player.roster_id ? { ...p, present: !p.present } : p);
      setSelectedPlayers(updatedPlayers);
    } else {

      const newPlayer = {
        r_id: player?.roster_id,
        t_id: eventData?.event_team_a_id,
        event_id: eventData?.event_id,
        eg_id: eventData?.event_group_id,
        present: true,
        startinglinup: false,
        play_sec: 0,
      };
      setSelectedPlayers([...selectedPlayers, newPlayer]);
    }
  };
  const handlePlayerJoin2 = (player) => {

    // Check if the player is already selected
    const isSelected = selectedPlayers2.some(p => p.r_id === player.roster_id);

    if (isSelected) {

      const updatedPlayers = selectedPlayers2.map(p => p.r_id === player.roster_id ? { ...p, present: !p.present } : p);
      setSelectedPlayers2(updatedPlayers);
    } else {

      const newPlayer = {
        r_id: player?.roster_id,
        t_id: eventData?.event_team_b_id,
        event_id: eventData?.event_id,
        eg_id: eventData?.event_group_id,
        present: true,
        startinglinup: false,
        play_sec: 0
      };
      setSelectedPlayers2([...selectedPlayers2, newPlayer]);
    }
  };



  const handleRosterJoin = async () => {
    setLoading(true)
    const formdata = new FormData();
    formdata.append("data", JSON.stringify([
      ...selectedPlayers,
      ...selectedPlayers2
    ]));
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/", formdata,
        {
          headers: {
            "Authorization": `${token}`,
          },
        }
      );

      if (response.data.data !== null) {
        setLoading(false)
        // Force refresh event data after roster join
        setEventDataReload(true);
      }
    } catch (error) {
      console.error("Error submitting team one data:", error);
      setLoading(false);
    }
  };


  const handlePlayerJoinPost = async () => {
    setLoading(true)
    const formdata = new FormData();
    formdata.append("data", JSON.stringify([
      ...selectedPlayers
    ]));
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/", formdata,
        {
          headers: {
            "Authorization": `${token}`,
          },
        }
      );

      if (response.data.data !== null) {


        setLoading(false)

      }
    } catch (error) {
      console.error("Error submitting team one data:", error);
    }
  };
  const handlePlayerJoinPost2 = async () => {
    setLoading(true)
    const formdata = new FormData();
    formdata.append("data", JSON.stringify([
      ...selectedPlayers2
    ]));
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_ROOT}` + "/api/playerStatus/", formdata,
        {
          headers: {
            "Authorization": `${token}`,
          },
        }
      );

      if (response.data.data !== null) {


        setLoading(false)

      }
    } catch (error) {
      console.error("Error submitting team one data:", error);
    }
  };

  const [sortedPlayers, setSortedPlayers] = useState(null);
  const [sortOrder, setSortOrder] = useState('asc'); // Default sort order

  const [currentSort, setCurrentSort] = useState('none'); // 'none', 'jersey', 'roster'

  // Function to handle sorting based on Jersey No
  const handleSortByJerseyNo = () => {
    const sorted = [...eventData.team_a_rosters].sort((a, b) => {
      if (sortOrder === 'asc') {
        return a.jersey_number - b.jersey_number;
      } else {
        return b.jersey_number - a.jersey_number;
      }
    });
    setSortedPlayers(sorted);
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc'); // Toggle sort order
    setCurrentSort('jersey'); // Set current sort to jersey
  };

  const [sortedPlayers2, setSortedPlayers2] = useState(null);
  const [sortOrder2, setSortOrder2] = useState('asc'); // Default sort order
  const [currentSort2, setCurrentSort2] = useState('none'); // 'none', 'jersey', 'roster' for team2

  const handleSortByJerseyNo2 = () => {
    const sorted2 = [...eventData.team_b_rosters].sort((a, b) => {
      if (sortOrder2 === 'asc') {
        return a.jersey_number - b.jersey_number;
      } else {
        return b.jersey_number - a.jersey_number;
      }
    });
    setSortedPlayers2(sorted2);
    setSortOrder2(sortOrder2 === 'asc' ? 'desc' : 'asc'); // Toggle sort order
    setCurrentSort2('jersey'); // Set current sort to jersey for team2
  };
  const [sortedPlayersByRosterId2, setSortedPlayersByRosterId2] = useState(null);
  const [sortOrderRosterId2, setSortOrderRosterId2] = useState('asc'); // Default sort order

  const handleSortByRosterId2 = () => {
    const sorted2 = [...eventData.team_b_rosters].sort((a, b) => {
      if (sortOrderRosterId2 === 'asc') {
        return a.roster_id - b.roster_id;
      } else {
        return b.roster_id - a.roster_id;
      }
    });
    setSortedPlayersByRosterId2(sorted2);
    setSortOrderRosterId2(sortOrderRosterId2 === 'asc' ? 'desc' : 'asc'); // Toggle sort order
    setCurrentSort2('roster'); // Set current sort to roster for team2
  };


  const [sortedPlayersByRosterId, setSortedPlayersByRosterId] = useState(null);
  const [sortOrderRosterId, setSortOrderRosterId] = useState('asc'); // Default sort order

  // Function to handle sorting based on Roster ID
  const handleSortByRosterId = () => {
    const sorted = [...eventData.team_a_rosters].sort((a, b) => {
      if (sortOrderRosterId === 'asc') {
        return a.roster_id - b.roster_id;
      } else {
        return b.roster_id - a.roster_id;
      }
    });
    setSortedPlayersByRosterId(sorted);
    setSortOrderRosterId(sortOrderRosterId === 'asc' ? 'desc' : 'asc'); // Toggle sort order
    setCurrentSort('roster'); // Set current sort to roster
  };


  const [sortedPlayersByUserId, setSortedPlayersByUserId] = useState(null);
  const [sortOrderUserId, setSortOrderUserId] = useState('asc'); // Default sort order

  // Function to handle sorting based on User ID
  const handleSortByUserId = () => {

    if (!eventData || !eventData.team_a_rosters) return;

    const sorted = [...eventData.team_a_rosters].sort((a, b) => {
      if (sortOrderUserId === 'asc') {
        return a.user_id - b.user_id;
      } else {
        return b.user_id - a.user_id;
      }
    });
    setSortedPlayersByUserId(sorted);
    setSortOrderUserId(sortOrderUserId === 'asc' ? 'desc' : 'asc'); // Toggle sort order
    setCurrentSort('user'); // Set current sort to user
  };
  const [sortedPlayersByUserId2, setSortedPlayersByUserId2] = useState(null);
  const [sortOrderUserId2, setSortOrderUserId2] = useState('asc'); // Default sort order

  // Function to handle sorting based on User ID
  const handleSortByUserId2 = () => {

    if (!eventData || !eventData.team_b_rosters) return;

    const sorted = [...eventData.team_b_rosters].sort((a, b) => {
      if (sortOrderUserId2 === 'asc') {
        return a.user_id - b.user_id;
      } else {
        return b.user_id - a.user_id;
      }
    });
    setSortedPlayersByUserId2(sorted);
    setSortOrderUserId2(sortOrderUserId2 === 'asc' ? 'desc' : 'asc'); // Toggle sort order
    setCurrentSort2('user'); // Set current sort to user
  };



  const eventDate = new Date(event_date_start);
  const isRosterLocked = event_date_start && eventDate < new Date();

  const handleToggleAddModal = (team) => {
    if (isRosterLocked) {
      toast.error("Roster is locked — event has already started");
      return;
    }
    if (team === "a") {
      setTeamOneAddModal(prev => !prev);
    } else {
      setTeamTwoAddModal(prev => !prev);
    }
  };


  const [searchTerm, setSearchTerm] = useState(''); // State for search term
  const [searchTerm2, setSearchTerm2] = useState(''); // State for search term

  // Filtered user data based on search term
  const filteredUsersTeamOne = eventData?.team_a_rosters?.filter(user => {
    const userId = user?.user_id?.toString().toLowerCase(); // Ensure user_id is a string
    return !searchTerm || (userId && userId.includes(searchTerm.toLowerCase()));
  });


  const filteredUsersTeamTwo = eventData?.team_b_rosters?.filter(user => {
    const userId = user?.user_id?.toString().toLowerCase(); // Ensure user_id is a string
    return !searchTerm2 || (userId && userId.includes(searchTerm2.toLowerCase()));
  });

  const [setting, setSetting] = useState(false);


  const fetchSettings = async () => {
    setLoading(true);
    try {
      const url = `${process.env.REACT_APP_API_ROOT}/api/get_Setting/`;
      const formData = new FormData();
      formData.append("e_id", eventId);
      const response = await fetch(url, {
        method: 'post',
        headers: {
          'X-TOKEN': `${token}`
        },
        body: formData
      });
      const responseData = await response.json();
      setSetting(responseData);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };
  useEffect(() => {
    fetchSettings();
  }, [eventId]);


  useEffect(() => {
    if (setting) {
      dispatch(fiveXFiveDefaultPeriod(setting?.time_period))
      dispatch(fiveXFiveOvertimePeriod(setting?.time_overtime));
      dispatch(topTimerWhenFoulCalled(setting?.time_overtime));
      dispatch(toggleShotClockCheck(setting?.shot_clock));
      dispatch(toggleShotClockViolation(setting?.rst_shot_clock_violation));
      dispatch(toggleFoul(setting?.rst_foul));
      dispatch(toggleTimeout(setting?.rst_timeout));
      dispatch(toggleOutOfBounds(setting?.rst_outofbounds));
      dispatch(toggleGoalWithinLast2Minutes(setting?.rst_goallast2min));
      dispatch(toggleGoalAnytimeDuringOvertime(setting?.rst_goal_anytime_overtime));
    }
  }, [setting])


  return (
    <div>
      {
        eventData ? <div className="bg-[#f2f2f2] w-full min-h-screen overflow-hidden">
          <div className="max-w-[1000px] xl:max-w-[1270px] 2xl:max-w-[1512px] w-full px-6 mx-auto  py-4 flex justify-between items-center flex-wrap lg:flex-auto">
            <div className="font-bebas md:text-5xl text-2xl text-[#1A1A1A] ">
              Players & Official
            </div>
            <div className="flex items-center gap-4 ">
              <div className="font-bebas text-2xl text-[#7D7D7D]">Game Mode</div>
              <div className="font-bebas text-2xl text-[#4A4A4A]">{eventType}</div>
            </div>
            <div className="flex items-center md:gap-3 gap-1 md:max-w-[375px] max-w-full w-full py-6">
              <button onClick={() => goBack()} className="flex md:justify-center justify-start items-center gap-2 w-full cursor-pointer">
                <IconCollection customClass='md:max-w-[24px] max-w-[16px] w-full md:h-[24px] h-[16px]' name="arrow-left" />
                <p className="text-[#4A4A4A] text-xl font-montserrat font-medium">
                  cancel
                </p>
              </button>
              <button
                onClick={() => [
                  handlePlayerAndOfficialData(),
                  setEventDataReload(true),

                ]}
                className="font-bebas bg-primary rounded-sm md:rounded  max-w-[50px] md:max-w-[87px] w-full h-6 md:h-12 flex justify-center items-center text-light text-base md:text-2xl"
              >

                {loading ?
                  <div className='max-w-[50px] md:max-w-[87px] w-full h-6 md:h-12 flex justify-center items-center overflow-hidden'>
                    <Loader />
                  </div>

                  : 'save'}
              </button>
              <button
                // disabled={
                //   loading ||
                //   teamOnePlayerPlayingLength <= 5 ||
                //   teamTwoPlayerPlayingLength <= 5
                // }
                onClick={() => handleGoToControlPage()}
                className=" max-w-[120px] w-full flex justify-center  text-base md:text-base h-6 md:h-12 px-2 items-center rounded-sm md:rounded bg-primary font-bebas text-light disabled:text-white disabled:bg-gray-500"

              >

                Go to Control Page

              </button>
              <button
                onClick={() => handleGoToStarterSubstitution()}
                // disabled={
                //   loading ||
                //   teamOnePlayerPlayingLength <= 5 ||
                //   teamTwoPlayerPlayingLength <= 5
                // }
                className="flex justify-center items-center gap-2 cursor-pointer max-w-[24px] w-full h-[24px] disabled:text-gray-500 text-[#4A4A4A]">
                <svg className='max-w-[24px] w-full h-[24px] ' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M13.1717 12.0007L8.22192 7.05093L9.63614 5.63672L16.0001 12.0007L9.63614 18.3646L8.22192 16.9504L13.1717 12.0007Z"></path></svg>
              </button>

            </div>
          </div>
          <div className="w-full h-[1px] border-b-[1px] border-b-[#CCCCCC]"></div>
          <div className="max-w-[1008px] xl:max-w-[1270px] 2xl:max-w-[1512px] w-full 2xl:px-6 px-4 mx-auto flex lg:flex-row flex-col">
            <div className="max-w-full lg:max-w-[600px] xl:max-w-[880px] 2xl:max-w-[980px] w-full md:pr-6 pr-0 flex-grow lg:border-r-[1px] border-r-0 border-[#CCCCCC] mb-14  ">
              <div className="h-14 border-b-[1px] border-[#CCCCCC] flex justify-center items-center gap-10">
                <button
                  onClick={() => setTab("team1")}
                  className={`font-rubik text-xl  ${tab == "team1"
                    ? "text-primary font-medium border-b-[2px] border-primary"
                    : "text-gray-400 font-normal border-none"
                    }  px-5 py-3   cursor-pointer`}
                >
                  {eventData?.team_a_short_name}
                </button>
                <button
                  onClick={() => setTab("team2")}
                  className={`font-rubik text-xl  ${tab == "team2"
                    ? "text-primary font-medium border-b-[2px] border-primary"
                    : "text-gray-400 font-normal border-none"
                    }  px-5 py-3   cursor-pointer`}
                >
                  {eventData?.team_b_short_name}
                </button>
              </div>

              <div className="my-4 text-[#4A4A4A] flex justify-center items-center font-bebas text-4xl h-[76px]">
                Players
              </div>

              {tab == "team1" && (
                <div className="max-w-[960px] overflow-x-auto overflow-y-clip">

                  <TableHeader
                    handleSortByRosterId={handleSortByRosterId}
                    handleSortByJerseyNo={handleSortByJerseyNo}
                    checkBoxOnChange={handleSelectUnselectAllTeamOne}
                    teamPlayerPlayingLength={teamOnePlayerPlayingLength}
                    defaultValue={eventData?.team_a_rosters?.length === (teamOnePlayerPlayingLength)}
                    searchUserID={searchUserID}
                    setSearchTerm={setSearchTerm}
                    setSearchUserID={setSearchUserID}
                    setCurrentSort={setCurrentSort}
                    handleSortByUserId={handleSortByUserId}

                  />
                  <TableBody
                    currentSort={currentSort}
                    sortedPlayersByUserId={sortedPlayersByUserId}
                    sortedPlayers={sortedPlayers}
                    sortedPlayersByRosterId={sortedPlayersByRosterId}
                    filteredUsers={filteredUsersTeamOne}
                    selectedPlayers={selectedPlayers}
                    handlePlayerJoin={handlePlayerJoin}
                  />

                  {teamOneAddModal ? (
                    <div className="mt-4">
                      <PlayerAddForm
                        eventData={eventData}
                        teamId={eventData?.event_team_a_id}
                        teamName={eventData?.team_a_short_name}
                        existingRosters={eventData?.team_a_rosters}
                        token={token}
                        onSuccess={handlePlayerAdded}
                        onCancel={() => setTeamOneAddModal(false)}
                      />
                    </div>
                  ) : (
                    <div className="flex justify-end mt-4">
                      <button onClick={() => handleToggleAddModal("a")}>
                        <IconCollection name="plus-icon" />
                      </button>
                    </div>
                  )}
                </div>
              )}
              {tab == "team2" && (

                <div className="max-w-[960px]  overflow-x-auto overflow-y-clip">
                  <TableHeader
                    handleSortByRosterId={handleSortByRosterId2}
                    handleSortByJerseyNo={handleSortByJerseyNo2}
                    checkBoxOnChange={handleSelectUnselectAllTeamTwo}
                    teamPlayerPlayingLength={teamTwoPlayerPlayingLength}
                    defaultValue={eventData?.team_b_rosters?.length === (teamTwoPlayerPlayingLength)}
                    searchUserID={searchUserID2}
                    setSearchTerm={setSearchTerm2}
                    setSearchUserID={setSearchUserID2}
                    setCurrentSort={setCurrentSort2}
                    handleSortByUserId={handleSortByUserId2}

                  />


                  <TableBody
                    currentSort={currentSort2}
                    sortedPlayersByUserId={sortedPlayersByUserId2}
                    sortedPlayers={sortedPlayers2}
                    sortedPlayersByRosterId={sortedPlayersByRosterId2}
                    filteredUsers={filteredUsersTeamTwo}
                    selectedPlayers={selectedPlayers2}
                    handlePlayerJoin={handlePlayerJoin2}
                  />

                  {teamTwoAddModal ? (
                    <div className="mt-4">
                      <PlayerAddForm
                        eventData={eventData}
                        teamId={eventData?.event_team_b_id}
                        teamName={eventData?.team_b_short_name}
                        existingRosters={eventData?.team_b_rosters}
                        token={token}
                        onSuccess={handlePlayerAdded}
                        onCancel={() => setTeamTwoAddModal(false)}
                      />
                    </div>
                  ) : (
                    <div className="flex justify-end mt-4">
                      <button onClick={() => handleToggleAddModal("b")}>
                        <IconCollection name="plus-icon" />
                      </button>
                    </div>
                  )}


                </div>
              )}

            </div>
            <div className="max-w-full lg:max-w-[358px] 2xl:max-w-full w-full md:pl-6 pl-0  mb-2">
              <div className="h-[76px] flex justify-center items-center ">
                <p className="text-[#4A4A4A] font-bebas text-3xl text-center">
                  Official
                </p>
              </div>
              <div className="w-full">
                {tab === "team1" ? (
                  teamOneOfficialLoading ? (
                    <Loader /> // Display loader for team 1
                  ) : (
                    <Official officialList={teamOneOfficial} />
                  )
                ) : (
                  teamTwoOfficialLoading ? (
                    <Loader /> // Display loader for team 2
                  ) : (
                    <Official officialList={teamTwoOfficial} />
                  )
                )}
              </div>
            </div>
          </div>
        </div> : (
          errorMessage
            ?
            <div className='flex flex-col gap-10 min-h-screen justify-center items-center'>

              <div className='font-bebas text-3xl md:text-4xl lg:text-6xl text-center leading-snug'>

                No teams selected for this event.
                <br />
                Please add the teams in the CMS
              </div>
              <Link className='px-4 py-2 bg-primary text-sm md:text-xl lg:text-2xl rounded-md font-montserrat text-white' to="/">
                Go to Home Page
              </Link>
            </div>
            :
            <Loading />
        )
      }
    </div>
  );
};

export default Players;

